import { Type } from '@angular/core';

export class AdItemModel {
  constructor(public component: Type<any>, public data: any) {}
}
